/**
 * The fetch a report goes to the gateway with (ADR-081's amendments of 2026-10-03 on P1.9-T72 and of 2026-10-05): every post carries the page's
 * current session token as `Authorization: Bearer`, read at the moment of sending so a refreshed session's token is the
 * one presented, and no cookie (`credentials: "omit"`), since the gateway's route reads none.
 */

/**
 * A fetch as the sender calls it.
 */
export type WidgetFetch = (input: string, init?: RequestInit) => Promise<Response>;

/**
 * Wraps a fetch so each request carries the current session token.
 *
 * @param token Reads the page's current session token, or null when it holds none.
 * @param fetcher The underlying fetch.
 * @returns The wrapped fetch; with no token it sends no `Authorization`, and the gateway answers 401.
 */
export function bearerFetch(token: () => string | null, fetcher: WidgetFetch): WidgetFetch {
  return (input, init) => {
    const headers = new Headers(init?.headers);
    const current = token();
    if (current === null || current === "") {
      headers.delete("Authorization");
    } else {
      headers.set("Authorization", `Bearer ${current}`);
    }
    return fetcher(input, { ...init, headers, credentials: "omit" });
  };
}
